// Slides the PDP media gallery to a variant's image when the variant changes.
// Keys off the native Shopify variant-image association (variant.featured_media,
// surfaced as data-variant-id on each slide by product_images.liquid) — never
// alt text. Loaded only by sections/product.liquid and sections/product-pro.liquid.
(function () {
  'use strict';

  // Map a variant id to its real slide index. pdpSlider runs in loop mode, where
  // Swiper clones and reorders slides, so trust its data-swiper-slide-index (the
  // original index, stamped on real slides and clones alike) rather than DOM
  // position. Falls back to position when it's absent (no loop). The real index
  // is what slideToLoop/slideTo expect.
  function findRealIndex(slider, variantId) {
    var vid = String(variantId);
    var slides = slider.slides;
    for (var i = 0; i < slides.length; i++) {
      var ids = slides[i].getAttribute('data-variant-id');
      if (!ids || ids.split(' ').indexOf(vid) === -1) continue;
      var realIndex = slides[i].getAttribute('data-swiper-slide-index');
      return realIndex === null ? i : parseInt(realIndex, 10);
    }
    return -1;
  }

  function syncGalleryToVariant(variant) {
    var slider = window.pdpSlider;
    if (!variant || !slider || slider.destroyed) return;
    var index = findRealIndex(slider, variant.id);
    if (index < 0) return;
    if (slider.params && slider.params.loop) {
      slider.slideToLoop(index);
    } else {
      slider.slideTo(index);
    }
  }

  document.addEventListener('variant:change', function (event) {
    syncGalleryToVariant(event.detail && event.detail.variant);
  });
})();
